<template>
  <div v-if="!loading" class="sp-mode">
    <sp-site-header/>
    <article>
      <div id="updateDate">
        <div class="container">
          <h1 v-if="area">{{ area.display_name }}エリア</h1>
          <span class="update_time" v-if="todayDelays.created_at">{{ todayDelays.created_at | jpfulltime }}更新</span>
        </div>
      </div>
      <div class="container">
        <div class="site_info" v-if="siteInfo" v-html="siteInfo"></div>
        <div v-if="areaInfoCSV" class ="site_info" v-html="areaInfoCSV"></div>
        <div v-if="maintenanceCSV && checkMaintenance()" id="maintenance_csv" v-html="maintenanceCSV"></div>
      </div>
      <div class="container line-accordion" role="tablist" v-if="linesInfo()">
        <div no-body v-bind:key="lineInfo.line_id" v-for="lineInfo in linesInfo()" class="line-item">
          <b-card-header header-tag="header" role="tab">
            <a v-b-toggle="'accordion-' + `${lineInfo.line_id}`">
              <span v-bind:class="{ delayexist: delayExists(lineInfo.line_id) == true }"><font-awesome-icon :icon="['fas', 'chevron-down']"></font-awesome-icon></span>
              <span v-bind:class="{ delayexist: delayExists(lineInfo.line_id) == true }"><font-awesome-icon :icon="['fas', 'chevron-up']"></font-awesome-icon></span>
              <span class="line-mark">
                <i :style="{ background: lineInfo.line_color_1, color: lineSignColor(lineInfo.line_sign_color_1) }">{{ lineInfo.line_sign_1 }}</i>
                <i v-if="lineInfo.line_sign_2" :style="{ background: lineInfo.line_color_2, color: lineSignColor(lineInfo.line_sign_color_2) }">{{ lineInfo.line_sign_2 }}</i>
                <i v-if="lineInfo.line_sign_3" :style="{ background: lineInfo.line_color_3, color: lineSignColor(lineInfo.line_sign_color_3) }">{{ lineInfo.line_sign_3 }}</i>
              </span>
              <div class="line-info">
                <span class="line-name">{{ lineInfo.line_name }}</span>
                <span class="section-name">{{ lineInfo.section_name }}</span>
              </div>
            </a>
            <b-button class="history-btn" v-on:click="onHistory(lineInfo.line_id)">履歴 <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon></b-button>
          </b-card-header>
          <b-collapse :id="'accordion-' + `${lineInfo.line_id}`" accordion="my-accordion" role="tabpanel">
            <table>
              <tbody>
                <tr class="text-center" v-bind:key="timeZone.time_zone_id" v-for="timeZone in timeZones">
                  <td class="timeZone-label" v-if="getTodayLineTimezoneDelay(lineInfo.line_id, timeZone.time_zone_id)" v-bind:class="{ active: timeZone.time_zone_id == activeTimeZone }" :set="dc = getTodayLineTimezoneDelay(lineInfo.line_id, timeZone.time_zone_id)">{{ timeZone.display_name }}</td>
                  <td v-bind:class="{ active: timeZone.time_zone_id == activeTimeZone }" v-if="getTodayLineTimezoneDelay(lineInfo.line_id, timeZone.time_zone_id)" class="delay-info">
                    <router-link :to="{ name: 'SpTodayDelayDelayCertificate', params: { today:'today', areaId: areaId, lineId: lineInfo.line_id, timeZoneId: timeZone.time_zone_id }}" v-bind:class="{ is_modified: dc.is_modified === true }" v-if=" dc.delay_certificate_item_type === 'DELAY_CERTIFICATE'" target="_blank">
                      <div class="str-modified" v-html="getModifiedString(dc.is_modified)"></div>
                      <div class="arrow-right"><font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon></div>
                      <div class="delay-time">{{ dc.delay_certificate }}</div>
                    </router-link>
                    <div class="string-delay" v-bind:class="{ maintenance: dc.delay_certificate === '調整中' }" v-else-if="dc.delay_certificate_item_type === 'OTHERS'">
                      <div class="str-modified" v-html="getModifiedString(dc.is_modified)"></div>
                      <div class="str-delay-info">{{ dc.delay_certificate }}</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-collapse>
        </div>
      </div>
      <div class="comment container">
        ※ 路線名をタップすると、遅延証明書の掲載状況を表示します。<br>
        ※ 時分をタップすると、遅延証明書画面を表示します。<br>
        ※ 履歴をタップすると、過去45日間の履歴を表示します。
      </div>
    </article>
    <sp-site-footer/>
  </div>
</template>

<script>
import SpSiteHeader from '@/components/sp/SpSiteHeader'
import SpSiteFooter from '@/components/sp/SpSiteFooter'
import { mapState } from 'vuex'
export default {
  name: 'SpLineList',
  components: {
    SpSiteHeader,
    SpSiteFooter
  },
  methods: {
    getModifiedString (isModified) {
      if (isModified) {
        return '変更'
      } else {
        return '&nbsp;'
      }
    },
    isValidAreaId (num) {
      return num === undefined || /^\d+$/.test(num) === true
    },
    setAreaId () {
      if (this.$route.params.areaId > 0) {
        this.$store.dispatch('areaLine/setAreaId', this.$route.params.areaId)
      } else if (this.areas && this.areas[0].area_id) {
        this.$store.dispatch('areaLine/setAreaId', this.areas[0].area_id)
      }
    },
    onHistory (lineId) {
      this.$router.push({name: 'SpHistory', params: { areaId: this.areaId, lineId: lineId }})
    },
    linesInfo () {
      if (this.areas.length > 0) {
        const lines = this.areas.find(area => area.area_id === this.areaId).lines
        if (lines.length > 0) {
          return lines
        }
      }
    },
    getTodayLineTimezoneDelay (lineId, timeZoneId) {
      if (this.todayDelays && this.todayDelays.areas) {
        const lines = this.todayDelays.areas.find((area) => area.area_id === this.areaId).lines
        if (lines) {
          const line = lines.find((line) => line.line_id === lineId)
          if (line && line.delay_certificates) {
            return line.delay_certificates.find((data) => data.time_zone_id === timeZoneId)
          }
        }
      } else {
        return []
      }
    },
    delayExists (lineId) {
      if (this.todayDelays && this.todayDelays.areas) {
        const lines = this.todayDelays.areas.find((area) => area.area_id === this.areaId).lines
        if (lines) {
          const line = lines.find((line) => line.line_id === lineId)
          if (line) {
            return line.have_delay_certificate
          }
        }
      } else {
        return false
      }
    },
    checkMaintenance () {
      if (this.todayDelays && this.todayDelays.areas) {
        const linesDelay = this.todayDelays.areas.find(area => area.area_id === this.areaId)
        if (linesDelay && linesDelay.lines) {
          for (var line of linesDelay.lines) {
            if (line && line.delay_certificates) {
              for (var timeZoneDelay of line.delay_certificates) {
                if (timeZoneDelay.delay_certificate === '調整中') {
                  return true
                }
              }
            }
          }
        }
      }
      return false
    },
    lineSignColor (data) {
      return data === '' ? '#000' : data
    },
    init (checkMaster) {
      if (checkMaster && (this.areaStatus !== 'init' || this.timeZoneStatus !== 'init')) {
        return
      }
      this.setAreaId()
      if (this.area === undefined) {
        this.$router.push({path: '/404'})
      } else {
        this.$store.dispatch('delaycertificatetoday/all', [this.areas, this.timeZones])
        this.$store.dispatch('externalData/siteInfo')
        this.$store.dispatch('externalData/areaInfoCSV', this.areaId)
        this.$store.dispatch('externalData/maintenanceCSV', this.areaId)
        this.checkLoaded()
      }
    },
    checkLoaded () {
      const timer = setInterval(() => {
        if (this.todayDelayStatus === 'init') {
          clearInterval(timer)
          this.$store.commit('loading/setStatus', false)
        }
      }, 100)
    }
  },
  created () {
    if (!this.isValidAreaId(this.$route.params.areaId)) {
      this.$router.push({name: 'SpPageNotFound'})
      return
    }
    this.$store.dispatch('areaLine/all')
    this.$store.dispatch('timeZone/all')
    const unwatchAreaLine = this.$store.watch(
      (state) => state.areaLine.status,
      (value) => {
        if (value === 'init') {
          unwatchAreaLine()
          this.init(true)
        }
      }
    )
    const unwatchTimezone = this.$store.watch(
      (state) => state.timeZone.status,
      (value) => {
        if (value === 'init') {
          unwatchTimezone()
          this.init(true)
        }
      }
    )
  },
  watch: {
    $route (to, from) {
      this.init()
    },
    loadedAt (oldVal, newVal) {
      this.init()
    }
  },
  computed: {
    ...mapState('externalData', {
      siteInfo: state => state.siteInfo,
      areaInfoCSV: state => state.areaInfoCSV,
      maintenanceCSV: state => state.maintenanceCSV
    }),
    ...mapState('delaycertificatetoday', {
      todayDelays: state => state.todayDelays,
      todayDelayStatus: state => state.status
    }),
    ...mapState('timeZone', {
      timeZones: state => state.timeZones,
      timeZoneStatus: state => state.status,
      activeTimeZone: state => state.activeTimeZone
    }),
    ...mapState('areaLine', {
      areas: state => state.areas,
      areaId: state => state.areaId,
      area: state => state.area,
      areaStatus: state => state.status,
      loadedAt: state => state.loadedAt
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
.update_time {
  font-size: 1.0rem;
}
.line-item {
    border-bottom: solid 1px #ccc;
    padding-bottom: 0.46rem;
}
.card-header {
  border-radius: 0 !important;
  border-top: none !important;
  padding-bottom: 0.46rem !important;
}
.site_info {
  margin-top: 0.6rem;
  background: white;
  border: solid 1px #e6e6e6;
  padding: 1.25rem;
}
#updateDate {
  border-bottom: solid 2px #3070B3;
  height: 98px;
  padding-top: 25px;
  font-weight: 600;
  margin-bottom: 10px;
  h1 {
    font-size: 1.3rem;
    padding: 0;
    margin: 0;
    font-weight: 600 !important;
  }
  span {
    color: $primary;
  }
}
#maintenance_csv {
  border: solid 1px #fa7d00;
  background-color: #ffffff;
  padding: 1.25rem;
  color: #fa7d00;
  font-size: 0.875rem;
  margin: 0.6rem 0;
}
.comment {
  line-height: 1.5rem;
  font-size: 0.875rem;
  margin-top: 1.25rem;
}
.line-accordion {
  header {
    background-color: #fff;
    border-top: solid 1px #ccc;
    border-bottom: none;
    padding: 0.93rem 0.31rem 0.93rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    a {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      &.collapsed {
        .fa-chevron-down {
          display: inline-block;
        }
        .fa-chevron-up {
          display: none;
        }
      }
      &.not-collapsed {
        .fa-chevron-down {
          display: none;
        }
        .fa-chevron-up {
          display: inline-block;
        }
      }
      span {
        .fa-chevron-down {
          color: #bbb;
          width: 1.5rem;
          line-height: 1.5rem;
          font-size: 0.84rem;
        }
        .fa-chevron-up {
          color: #bbb;
          width: 1.5rem;
          line-height: 1.5rem;
          font-size: 0.84rem;
        }
        &.delayexist {
          .fa-chevron-down {
            color: $primary;
          }
          .fa-chevron-up {
            color: $primary;
          }
        }
      }
      .line-info {
        display: inline-block;
        margin-left: 0.44rem;
        flex: 1;
        span {
          display: block;
          &.line-name {
            font-size: 0.9rem;
            font-weight: 600;
            color: #1a1a1a;
          }
          &.section-name {
            font-size: 0.7rem;
            font-weight: 600;
            line-height: 0.7rem;
            color: #a7a7a7;
          }
        }
      }
      .line-mark {
        display: inline-block;
        font-weight: 600;
        i {
          display: block;
          height: 1.375rem;
          width: 1.375rem;
          text-align: center;
          margin-bottom: 1px;
          color: #fff;
          font-style: normal;
          font-size: 1rem;
          line-height: 1.375rem;
          padding: 0.05rem;
          border-radius: 0.15rem;
        }
      }
    }
    button {
      &.history-btn {
        width: 2.5rem;
        height: 1.8rem !important;
        font-weight: 600;
        border: solid 1px #ccc;
        background-color: #fff;
        border-radius: 1;
        color: black;
        font-size: 0.7rem;
        padding: 0 0 0 0;
        float: right;
      }
    }
  }
  table {
    width: 100%;
    border-collapse: separate;
    tr {
      line-height: 2.5rem;
      td {
        &.timeZone-label{
          width: 6.5rem;
          font-weight: 600;
          font-size: 0.8rem;
          background-color: #f5f5f5;
        }
        &.delay-info {
          a {
            border: solid 2px #abcbe8;
            width: 100%;
            display: block;
            position: relative;
            font-weight: 600;
            background-color: #e0f2ff;
            div {
              display: block;
              &.str-modified {
                padding-left: 0.3rem;
                font-size: 0.6rem;
                position: absolute;
                color: #fa7d00;
              }
              &.delay-time {
                font-size: 0.9rem !important;
              }
              &.arrow-right {
                width: 1rem;
                font-size: 1.0rem !important;
                position: absolute;
                right: 0;
              }
            }
          }
          .string-delay {
            color: #a7a7a7;
            padding: 2px;
            &.maintenance{
              color: #fa7d00;
            }
            div {
              &.str-modified {
                float: left;
                padding-left: 0.3rem;
                font-size: 0.6rem;
                position: absolute;
                color: #fa7d00;
              }
              &.str-delay-info {
                font-size: 0.75rem !important;
              }
            }
          }
        }
        &.no-info {
          width: 63.5%;
          color: #a7a7a7;
        }
        &.active {
          background-color: #e0f2ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/SpLineList.vue